// 事件状态 → 配色映射
const statusMap: Record<string, { cls: string; icon: string }> = {
  新瓜: { cls: 'bg-accent-100 text-accent-800', icon: 'ri-flashlight-fill' },
  发酵中: { cls: 'bg-primary-100 text-primary-700', icon: 'ri-fire-fill' },
  有后续: { cls: 'bg-secondary-100 text-secondary-800', icon: 'ri-restart-fill' },
  已反转: { cls: 'bg-foreground-100 text-foreground-700', icon: 'ri-refresh-fill' },
  已考古: { cls: 'bg-background-200 text-foreground-700', icon: 'ri-time-line' },
};

export function statusBadge(status: string) {
  const s = statusMap[status] || statusMap['发酵中'];
  return s;
}

export function heatColor(heat: number) {
  if (heat >= 95) return 'text-primary-600';
  if (heat >= 85) return 'text-secondary-600';
  return 'text-accent-600';
}